<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.pendingDeliveries'), $t('text.list')]">
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('placeholder.serialNoInnerSerialNo')"
          />
        </el-form-item>
        <!-- <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.customerName"
            :placeholder="$t('menu.customers')"
          />
        </el-form-item> -->
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('placeholder.productNoCustomerProductNo')"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="dealtAt"
            :start-placeholder="$t('rules.startAt', [$t('order.dealtAt')])"
            :end-placeholder="$t('rules.endAt', [$t('order.dealtAt')])"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.handle"
            :placeholder="$t('text.handle')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky :sticky-top="50" :viewport="1024" :is-rem="false">
        <vxe-toolbar
          ref="recordsToolbar"
          custom
          zoom
          class="table-toolbar"
          style="height: atuo"
        >
          <template v-slot:buttons>
            <div
              v-if="Permit.extendModels().includes('lmsO')"
              class="float-left mgl10"
            >
              <!-- 标记发货 -->
              <el-button
                type="warning"
                size="mini"
                class="mgb5"
                @click="deliver('signDeliver')"
                >{{ $t("deliverTypes.signDeliver") }}</el-button
              >
            </div>
            <el-dropdown class="mgl10" @command="print">
              <el-button type="default" size="mini">
                {{ $t("action.print") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="printA4Div">
                  {{ $t("action.printPickingList") }}
                  ({{ $t("action.printA4") }})
                </el-dropdown-item>
                <el-dropdown-item command="printTPDiv">
                  {{ $t("action.printPickingList") }}
                  ({{ $t("action.pringTP") }})
                </el-dropdown-item>
                <el-dropdown-item command="printDeliveryDiv">
                  {{ $t("action.printDelivery") }}
                </el-dropdown-item>
                <el-dropdown-item command="printQrcodeWidthCustomer">
                  {{ $t("action.printQrCode") }}(有客户)
                </el-dropdown-item>
                <el-dropdown-item command="printQrcodeWidthOutCustomer">
                  {{ $t("action.printQrCode") }}(无客户)
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <br />
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        :loading="loading"
        id="bargainsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        :row-class-name="calculateBgColor"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column field="flags" :title="$t('text.flag')" width="50">
          <template v-slot="{ row }">
            <span v-if="row.flags != null && row.flags != ''">
              <flag
                :name="flag"
                :size="14"
                v-for="flag in JSON.parse(row.flags)"
                :key="flag"
              ></flag>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="120"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red"
              >({{ $t("order.hurrySimple") }})</small
            >
            <span @click="showOrder(row)" class="font10">
              <s v-if="row.workflowState == 'canceled'" class="grey">{{
                row.serialNo
              }}</s>
              <span v-else class="blue">{{ row.serialNo }}</span>
            </span>
            <div>
              <state-label
                :state="row.workflowState"
                :permit="Permit.canActions('orderDealView')"
              >
                <span v-if="Permit.canActions('orderDealView')">
                  {{ $t("orderStates." + row.workflowState) }}
                </span>
                <span v-else>
                  {{ $t("orderStatesNoPermit." + row.workflowState) }}
                </span>
              </state-label>
              <small v-if="row.replaceDeliver" class="red">
                {{ $t("purchase.replaceDeliver") }}
              </small>
              <el-popover
                placement="right"
                width="300"
                trigger="click"
                v-if="
                  !canDeliveryDF(row) && row.deliveredQuantity != row.quantity
                "
              >
                <div>
                  <div class="lineH24">不可发货原因：</div>
                  <div
                    v-if="
                      Permit.currentTenant().config.deliveryStrict === true &&
                      row._bargain.deliveryAudit == null &&
                      row._bargain.settleType === 'now' &&
                      row._bargain.differAmount > 0
                    "
                    class="lineH24 orange"
                  >
                    该订单欠款未审核
                  </div>
                  <div
                    v-if="
                      row.replaceDeliver && row.dealQuantity !== row.quantity
                    "
                    class="lineH24 orange"
                  >
                    该订单是代发货,需全部完成才可发货
                  </div>
                  <div
                    v-if="
                      !row.replaceDeliver &&
                      row.dealQuantity <= row.deliveredQuantity
                    "
                    class="lineH24 orange"
                  >
                    可发货数量不足
                  </div>
                </div>
                <span slot="reference" class="popover-reference">
                  <svg-icon
                    icon-class="prohibit"
                    style="font-size: 14px"
                    class="mgl5"
                  ></svg-icon>
                </span>
              </el-popover>
              <div class="font10">
                {{ $t("text.owner") }}: {{ row.shopName }}
              </div>
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >

            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="60"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit || "" }}
            <div class="font10">
              {{ $t("order.dealQuantity") }}:{{ row.dealQuantity
              }}{{ row.unit }}
              <small v-if="row.orderReceives != null">
                ({{ row.orderReceives.map((r) => r.shopName).join(",") }})
              </small>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="deliveredQuantity"
          :title="$t('order.deliveredQuantity')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <div class="font10">
              <el-popover
                placement="right"
                width="600"
                trigger="click"
                @show="getDeliveries(row)"
              >
                <vxe-table
                  :data="deliveries"
                  id="deliverInfosTable"
                  row-id="id"
                  ref="deliverInfosTable"
                  class="recordsTable"
                  size="mini"
                  resizable
                  round
                  auto-resize
                  highlight-hover-row
                  :scroll-y="{ enabled: false }"
                >
                  <vxe-table-column
                    field="deliverType"
                    :title="$t('delivery.deliveryMethode')"
                    min-width="80px"
                  >
                    <template v-slot="{ row }">
                      <span v-if="row.deliverType != null">{{
                        $t("deliverTypes." + row.deliverType)
                      }}</span>
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="express"
                    :title="$t('delivery.express')"
                    min-width="80px"
                  />
                  <vxe-table-column
                    field="deliverMethodName"
                    :title="$t('delivery.channel')"
                    min-width="60px"
                  />
                  <vxe-table-column
                    field="tracking"
                    :title="$t('delivery.tracking')"
                    min-width="60px"
                  />
                  <vxe-table-column
                    field="attachment"
                    :title="$t('product.attachment')"
                    min-width="60px"
                  >
                    <template v-slot="{ row }">
                      <thumbnail-text :srcs="row.attachment" :text="'附件'" />
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="deliverBy"
                    :title="$t('delivery.deliverBy')"
                    min-width="80px"
                  />
                  <vxe-table-column
                    field="deliverAt"
                    :title="$t('delivery.deliverAt')"
                    min-width="110px"
                  />
                </vxe-table>
                <span slot="reference" class="popover-reference">
                  {{ row.deliveredQuantity }}{{ row.unit }}
                </span>
              </el-popover>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.handOverAt }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="dealtAt"
          :title="$t('order.dealtAt')"
          min-width="110"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="160"
        >
          <template v-slot="{ row, rowIndex }">
            <i
              slot="reference"
              class="el-icon-edit"
              @click="editRemark(row, rowIndex)"
            />

            <raw-html-limit-number
              :content="row.remark"
              :number="30"
              type="richText"
            />
            <div>
              <attribute :content="row.specJson" :number="6" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="dealRemark"
          :title="$t('order.dealRemark')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.dealRemark"
              :number="10"
              type="richText"
            />
            <div
              v-if="row.specJson != null && row.specJson != '[]'"
              class="font10"
            >
              {{ $t("product.specJson") }}:
              <raw-html-limit-number
                :content="Util.tranJSONArrToString(row.specJson)"
                :number="10"
              />
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span> 条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- ===== -->
    <drawer
      :title="$t('text.view', [$t('menu.orders')])"
      :visible.sync="showOrderDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-order :id="currentRowOrderId" />
    </drawer>
    <el-dialog
      :title="$t('rules.edit', [$t('text.remark')])"
      :close-on-click-modal="false"
      :visible.sync="editRemarkDF"
      width="50%"
    >
      <el-form label-width="80px">
        <tinymce-editor
          ref="editor"
          v-model="editRemarkObj.remark"
          :height="300"
        ></tinymce-editor>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editRemarkDoing"
          size="small"
          @click="editRemarkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editRemarkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 发货 -->
    <el-dialog
      :title="$t('action.deliver')"
      :close-on-click-modal="false"
      :visible.sync="deliverDF"
      width="80%"
    >
      <div class="center mgb10">
        <el-input
          size="small"
          v-model="deliverObj.scanSerialNo"
          :placeholder="$t('prompt.scanSerialNo')"
          style="width: 300px"
          autofocus
          @keypress.enter.native="serialNoEnterKeyUp"
        ></el-input>
      </div>
      <el-form ref="deliverObjForm" :model="deliverObj" label-width="80px">
        <table
          class="table"
          cellspacing="0"
          cellpadding="0"
          border="0"
          style="width: 100%"
        >
          <thead class="thead">
            <tr>
              <th width="80">{{ $t("product.images") }}</th>
              <th min-width="120">{{ $t("order.serialNo") }}</th>
              <th min-width="120">{{ $t("product.productNo") }}</th>
              <th min-width="80">{{ $t("text.quantity") }}</th>
              <th width="100px">{{ $t("order.deliveredQuantity") }}</th>
              <th width="100px">{{ $t("order.deliverQuantity") }}</th>
              <th min-width="80">{{ $t("text.remark") }}</th>
              <th min-width="80">{{ $t("order.dealRemark") }}</th>
              <th width="50px">{{ $t("text.action") }}</th>
            </tr>
          </thead>
          <tbody
            v-for="(row, rowIndex) in checkedBargains"
            :key="rowIndex"
            class="tbody"
          >
            <tr class="tbody-total">
              <td colspan="9">
                <span class="mgr5 float-left pdt7">
                  {{ row.serialNo }}
                </span>
                <el-input
                  size="small"
                  v-model="row.deliverRemark"
                  :placeholder="$t('delivery.remark')"
                  class="mgr5 float-left"
                  style="width: 150px; margin-left: 5px"
                />
                <span class="float-right font10 pdt7 mgr5">
                  <el-popover placement="right" width="300" trigger="click">
                    <div>
                      <div class="lineH24">
                        {{ $t("menu.customers") }}：{{ row.customerName }}
                      </div>
                      <div class="lineH24" v-if="row.customerType != null">
                        {{ $t("bargain.customerType") }}：
                        {{ $t("customerTypes." + row.customerType) }}
                      </div>
                      <div class="lineH24">
                        {{ $t("bargain.customerPhone") }}：
                        {{ row.customerPhone }}
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.country") }}：
                        <span v-if="row.customerCountry != null">{{
                          $t("countries." + row.customerCountry)
                        }}</span>
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.province") }}：{{ row.customerProvince }}
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.city") }}：{{ row.customerCity }}
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.address") }}：{{ row.customerAddress }}
                      </div>
                      <div class="lineH24">
                        {{ $t("customer.zipcode") }}：{{ row.customerZipcode }}
                      </div>
                    </div>
                    <span slot="reference" class="popover-reference">
                      {{ $t("menu.customers") }}：{{ row.customerName }}
                    </span>
                  </el-popover>
                </span>
              </td>
            </tr>

            <tr v-for="(item, itemIndex) in row.orders" :key="item.id">
              <td>
                <thumbnail :images="item.images"></thumbnail>
              </td>
              <td style="word-wrap: break-word">
                <small v-if="item.hurry" class="red">
                  ({{ $t("order.hurrySimple") }})
                </small>
                {{ item.serialNo }}
                <div>
                  <state-label :state="item.workflowState">
                    {{ $t("orderStates." + item.workflowState) }}
                  </state-label>
                  <small v-if="item.replaceDeliver" class="red">
                    {{ $t("purchase.replaceDeliver") }}
                  </small>
                </div>
              </td>
              <td>
                {{ item.productNo }}
                <div class="font10">{{ item.categoryName }}</div>
                <div class="font10">{{ item.color }} {{ item.size }}</div>
              </td>
              <td>
                {{ item.quantity }}{{ item.unit }}
                <div class="orange font10">
                  {{ $t("order.dealQuantity") }}: {{ item.dealQuantity
                  }}{{ item.unit }}
                </div>
              </td>
              <td>{{ item.deliveredQuantity }}{{ item.unit }}</td>
              <td>{{ item.deliverQuantity }}{{ item.unit }}</td>
              <td>
                <raw-html-limit-number
                  :content="item.remark"
                  :number="20"
                  type="richText"
                />
                <div>
                  <attribute :content="item.specJson" :number="6" />
                </div>
              </td>
              <td>
                <raw-html-limit-number
                  :content="item.dealRemark"
                  :number="10"
                  type="richText"
                />
              </td>
              <td>
                <el-button
                  type="text"
                  size="small"
                  @click="removeSelectedOrder(rowIndex, itemIndex)"
                  >{{ $t("text.remove") }}</el-button
                >
              </td>
            </tr>
          </tbody>
        </table>
        <el-row class="mgt10">
          <el-col :span="8">
            <el-form-item
              :prop="'batchSerialNo'"
              :rules="[
                {
                  required: true,
                  validator: validateBatchSerialNo,
                  trigger: 'blur',
                },
              ]"
              size="mini"
            >
              <small slot="label">{{ $t("delivery.batchSerialNo") }}</small>
              <el-input
                v-model="deliverObj.batchSerialNo"
                :placeholder="$t('prompt.alphabetNumberLine')"
                clearable
                style="width: 150px"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="deliverSubmitDoing"
          size="small"
          @click="deliverSubmit('deliver')"
          >{{ $t("action.deliver") }}</el-button
        >
        <el-button size="small" @click="deliverDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印 -->
    <el-dialog
      :title="$t('action.print')"
      :close-on-click-modal="false"
      :visible.sync="printDF"
      width="60%"
    >
      <el-form ref="expressDeliverForm">
        <vxe-table
          :data="deliveryBargains"
          :merge-cells="mergeCellsDialog"
          id="bargainsTable"
          row-id="id"
          ref="printBargainsTable"
          class="recordsTable"
          :row-class-name="calculateBgColorDialog"
          size="mini"
          resizable
          round
          auto-resize
          highlight-hover-row
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column
            field="images"
            :title="$t('product.images')"
            width="80"
          >
            <template v-slot="{ row }">
              <span v-if="!row.isBargain">
                <thumbnail :images="row.images"></thumbnail>
              </span>
              <div v-else>
                <span class="float-left">
                  {{ row.serialNo }}
                  <raw-html-limit-number
                    :content="row.deliveryRemark"
                    :number="28"
                    class="color-orange"
                  />
                </span>
                <span class="float-right mgr5">
                  <el-popover placement="right" width="300" trigger="click">
                    <div>
                      <div class="lineH24">
                        {{ $t("menu.customers") }}：{{ row.customerName }}
                      </div>
                      <div class="lineH24" v-if="row.customerType != null">
                        {{ $t("bargain.customerType") }}：
                        {{ $t("customerTypes." + row.customerType) }}
                      </div>
                      <div class="lineH24">
                        {{ $t("bargain.customerPhone") }}：
                        {{ row.customerPhone }}
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.country") }}：
                        <span v-if="row.customerCountry != null">{{
                          $t("countries." + row.customerCountry)
                        }}</span>
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.province") }}：{{ row.customerProvince }}
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.city") }}：{{ row.customerCity }}
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.address") }}：{{ row.customerAddress }}
                      </div>
                      <div class="lineH24">
                        {{ $t("customer.zipcode") }}：{{ row.customerZipcode }}
                      </div>
                    </div>
                    <span slot="reference" class="popover-reference">
                      {{ $t("menu.customers") }}：{{ row.customerName }}
                    </span>
                  </el-popover>
                </span>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="serialNo"
            :title="$t('text.serialNo')"
            min-width="120"
          >
            <template v-slot="{ row }">
              <small v-if="row.hurry" class="red">
                ({{ $t("order.hurrySimple") }})
              </small>
              {{ row.serialNo }}
              <div>
                <state-label :state="row.workflowState">
                  {{ $t("orderStates." + row.workflowState) }}
                </state-label>
                <small v-if="row.replaceDeliver" class="red">
                  {{ $t("purchase.replaceDeliver") }}
                </small>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="productNo"
            :title="$t('product.productNo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              {{ row.productNo }}
              <div class="font10">{{ row.categoryName }}</div>
              <div class="font10">{{ row.color }} {{ row.size }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="quantity"
            :title="$t('text.quantity')"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.quantity }}{{ row.unit }}
              <div class="orange font10">
                {{ $t("order.dealQuantity") }}: {{ row.dealQuantity
                }}{{ row.unit }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="deliveredQuantity"
            :title="$t('order.deliveredQuantity')"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.deliveredQuantity }}{{ row.unit }}
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="handOverAt"
            :title="$t('text.handOverAt')"
            min-width="110"
          >
          </vxe-table-column>
          <vxe-table-column
            field="remark"
            :title="$t('text.remark')"
            min-width="60"
          >
            <template v-slot="{ row }">
              <raw-html-limit-number
                :content="row.remark"
                :number="10"
                type="richText"
              />
              <div>
                <attribute :content="row.specJson" :number="6" />
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="50"
          >
            <template v-slot="{ row }">
              <template v-if="!row.isBargain">
                <el-button
                  type="text"
                  size="small"
                  @click="removeSelectedOrderDialog(row)"
                  >{{ $t("text.remove") }}</el-button
                >
              </template>
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="printDoing"
          size="small"
          @click="printSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="printDF = false">
          {{ $t("text.close") }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 热敏打印 -->
    <div id="printTPDiv" style="display: none">
      <div>
        <table
          v-for="record in checkedBargains"
          :key="record.id"
          style="
            width: 80mm;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            margin-bottom: 20px;
          "
        >
          <tr style="border: 1px solid #dfe5ec; text-align: center">
            <td>
              <barcode :value="record.serialNo" height="40px" />
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td>
              <div v-for="item of record.orders" :key="item.id" class="mb10">
                {{ item.productNo }}
                <small
                  >({{ item.categoryName }}&nbsp;{{ item.color }}&nbsp;{{
                    item.size
                  }})</small
                >
                :{{ item.quantity }}{{ item.unit }}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              {{ record.customerName }}
              <div>{{ record.customerPhone }}</div>
              <div>
                <span v-if="record.customerCountry != null">{{
                  $t("countries." + record.customerCountry)
                }}</span>
                {{ record.customerProvince }}{{ record.customerCity
                }}{{ record.customerAddress }}
              </div>
              <div>{{ record.customerZipcode }}</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- A4打印 -->
    <div id="printA4Div" style="display: none">
      <div>
        <div style="width: 100%; text-align: center; font-size: 20px">
          {{ $t("action.pickingList") }}
        </div>
        <br />
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            text-align: center;
          "
        >
          <tr style="border: 1px solid #dfe5ec">
            <th class="text-center" width="80px">#</th>
            <th style="width: 75px; border: 1px solid #dfe5ec; padding: 10px 0">
              {{ $t("product.images") }}
            </th>
            <th style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("order.serialNo") }}
            </th>
            <th style="border: 1px solid #dfe5ec; width: 80px">
              {{ $t("product.productNo") }}
            </th>
            <th style="border: 1px solid #dfe5ec; width: 60px">
              {{ $t("text.quantity") }}
            </th>
            <th style="border: 1px solid #dfe5ec; width: 60px">
              {{ $t("order.deliveredQuantity") }}
            </th>
            <th style="border: 1px solid #dfe5ec; width: 60px">
              {{ $t("order.unDeliveredQuantity") }}
            </th>
            <th style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("text.handOverAt") }}
            </th>
            <th style="border: 1px solid #dfe5ec">{{ $t("text.remark") }}</th>
          </tr>
          <tbody v-for="(record, index) in checkedBargains" :key="record.id">
            <tr style="background: #f0f8ff">
              <td style="text-align: center">{{ index + 1 }}</td>
              <td colspan="8" style="height: 40px; padding-right: 10px">
                <span style="float: left">{{ record.serialNo }}</span>
                <small style="float: right">
                  {{ record.customerName }}&nbsp;&nbsp;{{
                    record.customerPhone
                  }}&nbsp;&nbsp;
                  <span v-if="record.customerCountry != null">{{
                    $t("countries." + record.customerCountry)
                  }}</span>
                  {{ record.customerProvince || ""
                  }}{{ record.customerCity || ""
                  }}{{ record.customerAddress || "" }}
                </small>
              </td>
            </tr>
            <tr
              v-for="(item, itemIndex) in record.orders"
              :key="item.id"
              style="border: 1px solid #dfe5ec"
            >
              <td
                v-if="itemIndex == 0"
                style="border: 1px solid #dfe5ec; width: 120px"
                :rowspan="record.orders.length"
              >
                <qrcode
                  v-if="record.serialNo != null"
                  :value="record.serialNo"
                  :options="{ width: 100 }"
                  :tag="'img'"
                />
                <!-- :value="`|||bargain|${record.serialNo}`" -->
              </td>

              <td style="border: 1px solid #dfe5ec">
                <img :src="item.firstImage" style="width: 80px" />
              </td>
              <td style="border: 1px solid #dfe5ec">
                {{ item.serialNo }}
              </td>
              <td style="border: 1px solid #dfe5ec">
                {{ item.productNo }}
                <div style="font-size: 10px">
                  {{ item.categoryName }}
                </div>
                <div style="font-size: 10px">
                  {{ item.color }} {{ item.size }}
                </div>
              </td>
              <td style="border: 1px solid #dfe5ec">
                {{ item.quantity }}{{ item.unit || "" }}
              </td>
              <td style="border: 1px solid #dfe5ec">
                {{ item.deliveredQuantity }}{{ item.unit || "" }}
              </td>
              <td style="border: 1px solid #dfe5ec">
                {{ item.quantity - item.deliveredQuantity || 0
                }}{{ item.unit || "" }}
              </td>
              <td style="border: 1px solid #dfe5ec">
                {{ item.handOverAt }}
              </td>
              <td style="border: 1px solid #dfe5ec; text-align: left">
                <raw-html :content="item.remark" type="richText" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- 打印发货单 -->
    <div id="printDeliveryDiv" style="display: none">
      <div
        v-for="(record, index) in checkedBargains"
        :key="index"
        :style="
          'text-align:left;' + (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div style="text-align: center; font-size: 20px">
          {{ record.shopName }}
        </div>
        <div style="text-align: center">
          <span v-if="Permit.currentTenant.country != null">{{
            $t("countries." + Permit.currentTenant.country)
          }}</span>
          {{ Permit.currentTenant.province || ""
          }}{{ Permit.currentTenant.city || ""
          }}{{ Permit.currentTenant.address || "" }}
        </div>
        <div>
          <div>
            <span>
              {{ $t("bargain.customerName") }}：{{ record.customerName }}
            </span>
          </div>
          <div>
            <span>
              {{ $t("bargain.customerAddress") }}：
              <span v-if="record.customerCountry != null">{{
                $t("countries." + record.customerCountry)
              }}</span>
              {{ record.customerProvince || "" }}{{ record.customerCity || ""
              }}{{ record.customerAddress || "" }}
              <span
                v-if="
                  record.customerZipcode != null &&
                  record.customerZipcode.trim() != ''
                "
                >({{ record.customerZipcode }})</span
              >
            </span>

            <span style="margin-left: 40px"
              >{{ $t("bargain.customerPhone") }}：{{
                record.customerPhone
              }}</span
            >

            <span style="float: right"
              >日期： {{ Util.formatDate(new Date()) }}</span
            >
          </div>
          <div>
            <table
              style="
                width: 100%;
                border-collapse: collapse;
                border: 1px solid #dfe5ec;
                word-wrap: break-word;
                word-break: break-all;
              "
            >
              <tr style="border: 1px solid #dfe5ec">
                <td style="border: 1px solid #dfe5ec; width: 50px">序号</td>
                <td style="border: 1px solid #dfe5ec">
                  {{ $t("order.serialNo") }}
                </td>
                <td style="border: 1px solid #dfe5ec">
                  {{ $t("product.productNo") }}
                </td>
                <td style="border: 1px solid #dfe5ec">
                  {{ $t("product.color") }}
                </td>
                <td style="border: 1px solid #dfe5ec">
                  {{ $t("product.size") }}
                </td>
                <td style="border: 1px solid #dfe5ec; width: 50px">
                  {{ $t("text.quantity") }}
                </td>
                <td style="border: 1px solid #dfe5ec; width: 50px">
                  {{ $t("menu.units") }}
                </td>
                <td style="border: 1px solid #dfe5ec; width: 150px">
                  {{ $t("text.remark") }}
                </td>
              </tr>
              <tr
                v-for="(order, orderIndex) in record.orders"
                :key="orderIndex"
                style="border: 1px solid #dfe5ec"
              >
                <td style="border: 1px solid #dfe5ec">{{ orderIndex + 1 }}</td>
                <td style="border: 1px solid #dfe5ec">{{ order.serialNo }}</td>
                <td style="border: 1px solid #dfe5ec">{{ order.productNo }}</td>
                <td style="border: 1px solid #dfe5ec">{{ order.color }}</td>
                <td style="border: 1px solid #dfe5ec">{{ order.size }}</td>
                <td style="border: 1px solid #dfe5ec">{{ order.quantity }}</td>
                <td style="border: 1px solid #dfe5ec">{{ order.unit }}</td>
                <td style="border: 1px solid #dfe5ec">
                  <raw-html :content="order.remark" type="richText" />
                </td>
              </tr>
              <tr>
                <td colspan="5" style="border: 1px solid #dfe5ec">合计</td>
                <td style="border: 1px solid #dfe5ec">
                  {{ record._totalQuantity }}
                </td>
                <td style="border: 1px solid #dfe5ec"></td>
                <td style="border: 1px solid #dfe5ec"></td>
              </tr>
            </table>
          </div>
          <div>
            <span>送货人签字：</span>
            <span style="float: right; margin-right: 200px">收货人签字：</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 打印订单二维码(有客户信息) -->
    <div id="printQrcodeWidthCustomer" style="display: none">
      <div
        v-for="(record, recordIndex) in checkedBargains"
        :key="record.id"
        :style="{ 'page-break-before': recordIndex != 0 ? 'always' : '' }"
      >
        <div
          v-for="(item, index) in record.orders"
          :key="item.id"
          :style="{ 'page-break-before': index != 0 ? 'always' : '' }"
          align="center"
        >
          <table
            style="
              border-collapse: collapse;
              border: 1px solid #dfe5ec;
              word-wrap: break-word;
              word-break: break-all;
              text-align: center;
              font-size: 12px;
            "
          >
            <tbody>
              <tr style="border: 1px solid #dfe5ec">
                <td align="center">
                  <qrcode
                    v-if="item.serialNo != null"
                    :value="item.serialNo"
                    :options="{ width: 100 }"
                    :tag="'img'"
                  />
                  <!-- :value="`${item.productNo}|${item.color}|${item.size}|order|${item.serialNo}`" -->
                </td>
              </tr>
              <tr style="border: 1px solid #dfe5ec">
                <td>
                  <div>{{ item.serialNo }}</div>
                  <div>{{ item.productNo }}</div>
                  <div>{{ item.color }}-{{ item.size }}</div>
                  <div>{{ item.customerName }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 打印订单二维码（无客户信息） -->
    <div id="printQrcodeWidthOutCustomer" style="display: none">
      <div
        v-for="(record, recordIndex) in checkedBargains"
        :key="record.id"
        :style="{ 'page-break-before': recordIndex != 0 ? 'always' : '' }"
      >
        <div
          v-for="(item, index) in record.orders"
          :key="item.id"
          :style="{ 'page-break-before': index != 0 ? 'always' : '' }"
          align="center"
        >
          <table
            style="
              border-collapse: collapse;
              border: 1px solid #dfe5ec;
              word-wrap: break-word;
              word-break: break-all;
              text-align: center;
              font-size: 12px;
            "
          >
            <tbody>
              <tr style="border: 1px solid #dfe5ec">
                <td align="center">
                  <qrcode
                    v-if="item.serialNo != null"
                    :value="item.serialNo"
                    :options="{ width: 100 }"
                    :tag="'img'"
                  />
                  <!-- :value="`${item.productNo}|${item.color}|${item.size}|order|${item.serialNo}`" -->
                </td>
              </tr>
              <tr style="border: 1px solid #dfe5ec">
                <td>
                  <div>{{ item.serialNo }}</div>
                  <div>{{ item.productNo }}</div>
                  <div>{{ item.color }}-{{ item.size }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import ls from "store2";
import Barcode from "vue-barcode";
import Qrcode from "@chenfengyuan/vue-qrcode";

import { table, page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import DateRange from "@/components/DateRange";
import RawHtml from "@/components/RawHtml";
import ThumbnailText from "@/components/ThumbnailText";
import TinymceEditor from "@/components/TinymceEditor";

//
import Bargain from "@/api/bargain.js";
import Shop from "@/api/shop.js";
import Delivery from "@/api/delivery.js";
import Express from "@/api/express.js";
import Courier from "@/api/courier.js";
import Order from "@/api/order.js";

//
import ShowOrder from "@/views/oms/bargains/showOrder.vue";
import { countries } from "@/utils/enums.js";
import Cookies from "@/utils/cookies.js";
import { coreEndpoint } from "@/settings";
export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    TinymceEditor,
    ShowOrder,
    Barcode,
    Qrcode,
    RawHtml,
    ThumbnailText,
  },

  data() {
    var validateBatchSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(
            this.$t("rules.required", [this.$t("delivery.batchSerialNo")])
          )
        );
        return;
      }
      if (!Util.regexAlphabetNumberLine(value)) {
        callback(new Error(this.$t("prompt.regexAlphabetNumberLine")));
        return;
      }
      Delivery.findByBatchSerialNo({ batchSerialNo: value }).then(function (
        res
      ) {
        if (res.data.code === 200) {
          callback(
            new Error(
              self.$t("rules.exist", [self.$t("delivery.batchSerialNo")])
            )
          );
        } else {
          callback();
        }
      });
    };
    return {
      countries: countries,
      Util: Util,
      sorter: {
        sortBy: "orders_id",
        sortIndicator: "desc",
      },
      narrows: [
        [
          {
            label: this.$t("order.orderDeliverInfo"),
            items: [
              {
                label: this.$t("order.complete"),
                key: "yes",
                condition: { prepared: "yes" },
              },
            ],
          },
        ],
      ],
      initFilter: ["yes"],
      searchForm: {
        serialNo: null,
        customerName: null,
        productNo: null,
        dealtAtStartAt: null,
        dealtAtEndAt: null,
        handle: null,
      },
      deliveries: [],
      //
      currentRowIdx: null,
      currentRowOrderId: null,
      showOrderDF: false,
      //编辑备注
      currentRowIdx: null,
      editRemarkDF: false,
      editRemarkObj: {
        remark: null,
        uuid: null,
      },
      editRemarkDoing: false,
      // 发货
      validateBatchSerialNo: validateBatchSerialNo,
      deliverDF: false,
      deliverType: null,
      selectCourierTenant: null,
      selectExpressTenant: null,
      selectDeliverMethod: null,
      checkedBargains: [],
      checkedOrders: [],
      deliverObj: {
        scanSerialNo: null,
        express: null,
        deliverMethodId: null,
        batchSerialNo: Util.serialNo(),
      },
      deliverSubmitDoing: false,
      deliveryBargains: [],
      mergeCellsDialog: [],
      dialogType: null,
      // mergeCellsDeliver: [],
      //
      printType: [],
      printDF: false,
      printDoing: false,

      qingguanwenjianAction: null,
      name: null,
      fileHeaders: {
        type: "web",
        token: Cookies.getToken(),
      },
      lianbangDocId: null,
      lianbangCalcRateDoing: false,
      shipmentRateDetailFinish: null,
      lianmengCalcRateData: null,
      // eslint-disable-next-line vue/require-default-prop
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
  },
  methods: {
    //================
    print(type) {
      const self = this;
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      this.printType = type;
      this.printDoing = false;
      self.checkedBargains = [];
      let bargainIds = [...new Set(self.selectRecords.map((s) => s.bargainId))];
      Bargain.findByIds(bargainIds).then(function (res) {
        if (res.status == 200) {
          let checked_Bargains = res.data;
          for (const bargain of checked_Bargains) {
            const orders = self.selectRecords.filter(
              (o) => o.bargainId == bargain.id
            );
            Vue.set(bargain, "orders", orders);
            let totalQuantity = 0;
            for (const order of orders) {
              totalQuantity = order.quantity + totalQuantity;
              Vue.set(order, "customerName", bargain.customerName);
            }
            Vue.set(bargain, "_totalQuantity", totalQuantity);
            self.checkedBargains.push(bargain);
          }
          self.dialogType = "print";
          self.deliveryBargains = self.buildTableDataDialog(
            self.checkedBargains
          );
          self.mergeCellsDialog = self.buildMergeCellsDialog(
            self.checkedBargains
          );
          self.printDF = true;
        } else {
          self.sysError();
        }
      });
    },
    printSubmit() {
      this.printDoing = true;
      this.printDF = false;
      this.printFunction(this.printType);
      this.printDoing = false;
    },
    //
    buildTableDataDialog(records) {
      let rs = [];
      records.forEach((record) => {
        let bOrder = {
          isBargain: true,
          id: record.id,
          uuid: record.uuid,
          serialNo: record.serialNo,
          shopId: record.shopId,
          shopName: record.shopName,
          settleType: record.settleType,
          amount: record.amount,
          currency: record.currency,
          customerId: record.customerId,
          customerName: record.customerName,
          customerCountry: record.customerCountry,
          customerProvince: record.customerProvince,
          customerCity: record.customerCity,
          customerAddress: record.customerAddress,
          customerPhone: record.customerPhone,
          customerZipcode: record.customerZipcode,
          customerType: record.customerType,
          customerSource: record.customerSource,
          customerEmail: record.customerEmail,
          deliveryRemark: record.deliveryRemark,
          groupJson: record.groupJson,
          remark: record.remark,
          ownerId: record.ownerId,
          ownerName: record.ownerName,
          createAt: record.createAt,
          plateform: record.plateform,
          plateformBargainId: record.plateformBargainId,
          cnyAmount: record.cnyAmount,
          replaceCustomerId: record.replaceCustomerId,
          lastDealtAt: record.lastDealtAt,
          customer: record.customer,
          productAmount: record.productAmount,
          // currentMonthAmount: record.currentMonthAmount,
          plateformStoreId: record.plateformStoreId,
          financeDeliveryAt: record.financeDeliveryAt,
          deliveryAudit: record.deliveryAudit,
          financeAudit: record.financeAudit,
          payAmount: record.payAmount,
          productQty: record.productQty,
          differAmount: record.differAmount,
          ignoreAmount: record.ignoreAmount,
          orders: record.orders,
          deliverSerialNo: record.deliverSerialNo,
          goodsName: record.goodsName,
          goodsNameEn: record.goodsNameEn,
          hsCode: record.hsCode,
          weight: record.weight,
          insured: record.insured,
          tracking: record.tracking,
          sender: record.sender,
          deliverCost: record.deliverCost,
          extraCharge: record.extraCharge,
          deliverRemark: record.deliverRemark,
          toPay: record.toPay,
          _totalQuantity: record._totalQuantity,
        };
        rs.push(bOrder); //将bargain的数据转换到格式，放到数据列表
        record.orders.forEach((order) => {
          rs.push(order);
        });
      });
      return rs;
    },
    buildMergeCellsDialog(bargains) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < bargains.length; i++) {
        if (this.dialogType == "deliver") {
          mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 9 });
        }
        if (this.dialogType == "print") {
          mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 8 });
        }
        rowIdx = rowIdx + bargains[i].orders.length + 1;
      }
      return mcs;
    },
    calculateBgColorDialog({ row, rowIndex }) {
      return row.isBargain ? "light-blue-bg" : "";
    },
    removeSelectedOrderDialog(row) {
      const self = this;
      for (const bargainIndex in self.checkedBargains) {
        const orderIndex = self.checkedBargains[bargainIndex].orders.findIndex(
          (o) => o.id == row.id
        );
        if (orderIndex != -1) {
          self.checkedBargains[bargainIndex].orders.splice(orderIndex, 1);
        }
        if (self.checkedBargains[bargainIndex].orders.length == 0) {
          self.checkedBargains.splice(bargainIndex, 1);
        }
      }
      self.deliveryBargains = self.buildTableDataDialog(self.checkedBargains);
      self.mergeCellsDialog = self.buildMergeCellsDialog(self.checkedBargains);
    },
    // 发货================
    serialNoEnterKeyUp() {
      const self = this;
      Bargain.findBySerialNo({
        serialNo: self.deliverObj.scanSerialNo,
        tenantId: self.Permit.currentTenant().id,
      }).then(function (res) {
        if (res.data.code === 200) {
          const bargain = res.data.entity;
          Vue.set(bargain, "deliverSerialNo", bargain.serialNo);
          Vue.set(bargain, "goodsName", null);
          Vue.set(bargain, "goodsNameEn", null);
          Vue.set(bargain, "hsCode", null);
          Vue.set(bargain, "weight", null);
          Vue.set(bargain, "insured", null);
          Vue.set(bargain, "tracking", null);
          Vue.set(bargain, "sender", null);
          Vue.set(bargain, "deliverCost", null);
          Vue.set(bargain, "extraCharge", null);
          Vue.set(bargain, "deliverRemark", bargain.deliveryRemark);
          Vue.set(bargain, "toPay", false);
          Vue.set(bargain, "express", null); //
          for (const order of bargain.orders) {
            let maxDeliverQuantity =
              order.dealQuantity - order.deliveredQuantity;
            Vue.set(order, "_maxDeliverQuantity", maxDeliverQuantity);
            Vue.set(order, "deliverQuantity", maxDeliverQuantity);
          }
          bargain.orders = JSON.parse(JSON.stringify(bargain.orders)).filter(
            (o) => o._maxDeliverQuantity > 0
          );
          const serialNos = self.checkedBargains.map((s) => s.serialNo);
          if (serialNos.indexOf(bargain.serialNo) !== -1) {
            self.checkedBargains.splice(serialNos.indexOf(bargain.serialNo), 1);
            self.$message({
              message: self.$t("prompt.scanDeliveryUpdateSerialNo"),
              type: "warning",
            });
          }
          self.checkedBargains.push(bargain);
        } else {
          self.$message({
            message: self.$t("prompt.notExixtSerialNo"),
            type: "warning",
          });
          return;
        }
        self.deliverObj.scanSerialNo = null;
      });
    },
    deliver(deliverType) {
      const self = this;
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.deliverType = deliverType;
      //======
      let bargainIds = [];
      for (const order of self.selectRecords) {
        let maxDeliverQuantity = order.dealQuantity - order.deliveredQuantity;
        Vue.set(order, "_maxDeliverQuantity", maxDeliverQuantity);
        Vue.set(order, "deliverQuantity", maxDeliverQuantity);
        if (!bargainIds.includes(order.bargainId)) {
          bargainIds.push(order.bargainId);
        }
      }
      self.checkedBargains = [];
      Bargain.findByIds(bargainIds).then(function (res) {
        if (res.status == 200) {
          let checked_Bargains = res.data;
          for (const bargain of checked_Bargains) {
            let orders = self.selectRecords.filter(
              (o) => o.bargainId == bargain.id
            );
            Vue.set(bargain, "orders", orders);
            Vue.set(bargain, "deliverSerialNo", bargain.serialNo);
            Vue.set(bargain, "goodsName", null);
            Vue.set(bargain, "goodsNameEn", null);
            Vue.set(bargain, "hsCode", null);
            Vue.set(bargain, "weight", null);
            Vue.set(bargain, "insured", null);
            Vue.set(bargain, "tinNumber", null); // 联邦 税务号
            Vue.set(bargain, "currency", null); // 联邦 结算比重 USD美元 EUR 欧元
            Vue.set(bargain, "customsValue", null); // 联邦 货品总额
            Vue.set(bargain, "length", null); // 联邦
            Vue.set(bargain, "width", null); // 联邦
            Vue.set(bargain, "height", null); // 联邦
            Vue.set(bargain, "tracking", null);
            Vue.set(bargain, "deliverCost", null);
            Vue.set(bargain, "extraCharge", null);
            Vue.set(bargain, "deliverRemark", bargain.deliveryRemark);
            Vue.set(bargain, "toPay", false);
            self.checkedBargains.push(bargain);
          }
          self.dialogType = "deliver";
          self.deliverDF = true;
        } else {
          self.sysError();
        }
      });
    },
    removeSelectedOrder(index, itemIndex) {
      this.checkedBargains[index].orders.splice(itemIndex, 1);
      for (const bargain of this.checkedBargains) {
        if (bargain.orders.length === 0) {
          this.checkedBargains.splice(index, 1);
        }
      }
    },
    deliverSubmitData(submitType) {
      const self = this;
      const data = [];
      for (const s of self.checkedBargains) {
        const obj = {
          type: self.deliverType,
          serialNo: s.deliverSerialNo,
          remark: s.deliverRemark,
          extraCharge: s.extraCharge,
          toPay: s.toPay,
          //
          sender: s.sender,
          deliverCost: s.deliverCost,
          express: null,
          expressId: null,
          expressTenantId: null,
          courierId: null,
          courierName: null,
          deliverMethodId: null,
          deliverMethodName: null,
          tracking: s.tracking,
          weight: s.weight,
          insured: s.insured,
          deliverInfos: s.orders.map((o) => {
            return { orderId: o.id };
          }),
          isPrintEOrder: false,
          batchSerialNo: self.deliverObj.batchSerialNo,
          goodsName: s.goodsName,
          goodsNameEn: s.goodsNameEn,
          hsCode: s.hsCode,
          iossNum: s.iossNum,
          iossCountryCode: s.iossCountryCode,
          tinNumber: s.tinNumber, // 联邦 税务号
          currency: s.currency, // 联邦
          customsValue: s.customsValue, // 联邦
          length: s.length, // 联邦
          width: s.width, // 联邦
          height: s.height, // 联邦
        };
        data.push(obj);
      }
      return data;
    },
    deliverSubmit(type) {
      const self = this;
      if (this.checkedBargains.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.deliverSubmitDoing = true;
      for (const s of self.checkedBargains) {
        for (const o of s.orders) {
          if (
            !Util.regexQuantity(o.deliverQuantity) ||
            o.deliverQuantity === 0 ||
            o.deliverQuantity > o._maxDeliverQuantity
          ) {
            self.deliverSubmitDoing = false;
            this.$message.error(this.$t("prompt.deliveredQuantityBeyond"));
            return;
          }

          if (o.deliverQuantity > o.quantity) {
            self.deliverSubmitDoing = false;
            this.$message.error(this.$t("prompt.deliveredBeyondQuantity"));
            return;
          }
        }
      }
      this.$refs.deliverObjForm.validate((valid) => {
        if (valid) {
          // 自提、送货、标记发货
          if (["signDeliver"].includes(self.deliverType)) {
            self.deliverSubmitDoing = true;
            Order.normalDeliver(self.deliverSubmitData()).then(function (res) {
              self.deliverSubmitDoing = false;
              self.deliverDF = false;
              if (res.status === 200) {
                self.sysResults(res.data, self.$t("prompt.deliverSuccess"));
                self.loadData();
                self.$eventHub.$emit("orderNormalDeliver");
              } else {
                self.sysError();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // ========

    // 编辑备注==========
    editRemark(row, rowIndex) {
      this.editRemarkObj.uuid = row.uuid;
      this.editRemarkObj.remark = row.remark;
      this.currentRowIdx = rowIndex;
      this.editRemarkDoing = false;
      this.editRemarkDF = true;
    },
    editRemarkSubmit() {
      const self = this;
      self.editRemarkDoing = true;
      Order.updateRemark(self.editRemarkObj).then(function (res) {
        self.editRemarkDoing = false;
        self.editRemarkDF = false;
        if (res.status === 200) {
          self.records[self.currentRowIdx].remark = self.editRemarkObj.remark;
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    // 获取发货信息
    getDeliveries(row) {
      const self = this;
      Delivery.findByOrderUuid(row.uuid).then(function (res) {
        if (res.status == 200) {
          self.deliveries = res.data;
        } else {
          self.sysError();
        }
      });
    },

    //=========
    showOrder(row) {
      this.currentRowOrderId = row.id;
      this.showOrderDF = true;
    },
    // 可选
    checCheckboxMethod({ row }) {
      const canWorkflowStates = [
        "preparing",
        "prepared",
        "processing",
        "processed",
        "purchasing",
        "purchased",
        "partially",
        "shipped",
      ];
      if (row.replaceDeliver) {
        return (
          canWorkflowStates.includes(row.workflowState) &&
          row.dealQuantity === row.quantity
        );
      }
      return (
        canWorkflowStates.includes(row.workflowState) &&
        row.dealQuantity - row.deliveredQuantity > 0
      );
    },
    canDeliveryDF(row) {
      const canWorkflowStates = [
        "preparing",
        "prepared",
        "processing",
        "processed",
        "purchasing",
        "purchased",
        "partially",
        "shipped",
      ];
      if (row.replaceDeliver) {
        return (
          canWorkflowStates.includes(row.workflowState) &&
          row.dealQuantity === row.quantity
        );
      }
      return (
        canWorkflowStates.includes(row.workflowState) &&
        row.dealQuantity - row.deliveredQuantity > 0
      );
    },

    dataProvider(params) {
      return Order.pendingDeliverySearch(params);
    },
    calculateBgColor({ row, rowIndex }) {
      return this.rowBgColor({ row: row, rowIndex: rowIndex });
    },
    isNear(row) {
      //定义近交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (!noColorWorkflowStates.includes(row.workflowState)) {
        if (
          Util.dateDiff(row.handOverAt, new Date()) <=
            this.Permit.currentTenant().config.nearDays &&
          Util.dateDiff(row.handOverAt, new Date()) > 0
        ) {
          return true;
        }
      }
      return false;
    },
    isPass(row) {
      //定义过交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (!noColorWorkflowStates.includes(row.workflowState)) {
        if (Util.dateDiff(row.handOverAt, new Date()) <= 0) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
<style scoped>
.agentBg {
  margin-bottom: 5px;
  font-size: 14px;
}
.agentBg:hover {
  cursor: pointer;
  color: #409eff;
  background: #edf4fd;
}
.table {
  width: 100%;
  font-size: 14px;
}

.thead tr {
  height: 40px;
  line-height: 40px;
  color: #909399;
  font-weight: 500;
}

.tbody tr td {
  padding: 4px;
}
.tbody {
  color: #606266;
}
.tbody-total {
  background: #eff8ff;
}
.tbody td {
  border-bottom: 1px solid #ebeef5;
  text-align: left;
  padding-left: 6px;
}
.thead th {
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  text-align: left;
  padding-left: 6px;
}
</style>